import React from "react";
import Figure1 from "./Figure1";
import Figure2 from "./Figure2";
import Figure3 from "./Figure3";
import Figure4 from "./Figure4";
import Figure5 from "./Figure5";
import Figure6 from "./Figure6";
import Figure7 from "./Figure7";
import Figure8 from "./Figure8";
import Figure10 from "./Figure10";
import Figure11 from "./Figure11";
import {Figure12} from "./Figure16";
import {Figure13} from "./Figure17";
import {Figure16} from "./Figure16";
import {Figure17} from "./Figure17";


const Article = () => {
  return (
      
    <div className="mb-20">
      <div>
        {/*Figure 1*/}{/**GFP signal in od meter */}
        {/*Figure 2*/}{/**GFP signal standard curve */}
        {/*Figure 3*/}{/**GFP experiment 1 */}
        {/*Figure 4*/}{/**GFP optimization */}
        {/*Figure 5*/}{/**GFP assay 2 fluorescecne */}
        {/*Figure 6*/}{/**BCA standard table */}
        {/*Figure 7*/}{/**BCA standard curve */}
        {/*Figure 8*/}{/**BCA table */}
        {/*Figure 10*/}{/**PK enzymatic assay */}
        {/*Figure 11*/}{/**PK enzymatic assay */}
        {/*Figure 12*/}{/**SpaC Half life ODs */}{/**----------------- */}
        {/*Figure 13*/}{/**SpaC Half life volumes loaded 1 */}{/**----------------- */}
        {/*Figure 14*/}{/**SpaC Half life volumes loaded 2 */}{/**----------------- */}
        {/*Figure 15*/}{/**Mucus binding SpaC counts */}{/**----------------- */}
        {/*Figure 16*/}{/**Mucus binding final epxeriment count 1 */}
        {/*Figure 17*/}{/**Mucus binding final epxeriment count 2 */}
        {/*Figure 18*/}{/**Half-Life linear standard curve D2 */}
        {/*Figure 19*/}{/**Half-Life linear standard curve D1D2 */}
        



        
        <h2 id="SpaC_results_s">SpaC: </h2>
        <hr className="dividergeneral mb-5" />
          <p className="mb-2">
          In this section, we will present the results obtained in our pursuit of using the SpaC construct as an 
          anchoring system to facilitate the adhesion of our live biotherapeutic product (LBP) to the patient's 
          intestinal mucus.
          </p>

          <div>{/*Expression for different conditions */}
            <h3 className="mt-10 mb-5" id="Expression_SpaC_s">Expression of SpaC: </h3>
              <h4 className="mb-2">The induction system based on theophylline-riboswitch and IPTG works: </h4>
                <p className="mb-20">
                After inducing the SpaC-construct hosting bacterial strain under various experimental conditions 
                , we conducted a Western blot analysis (<a href="#Figure1_SpaC">Figure 1</a>). 
                Bands were detected at approximately 130 kDa, 
                slightly above the expected 122 kDa molecular weight of SpaC, confirming successful protein 
                expression at both 37°C and 18°C. Conversely, no signal was observed in the absence of 
                theophylline (Th) or Isopropyl-β-D-thiogalactopyranosid (IPTG), indicating no protein expression.<br></br>
                As previously reported{" "}<a href="#reference1_SpaC">{" "}<sup>1</sup>{" "}</a>, there was some 
                leakiness in the lac operon, as evidenced by the signal in the "Th only" condition. Furthermore, 
                consistent with the reduced riboswitch tightness at lower temperatures{" "}<a href="#reference2_SpaC">{" "}<sup>2</sup>{" "}</a>,
                a signal was observed in the IPTG condition at 18°C, whereas translation was suppressed at 37°C. <br></br>
                Notably, initiating the secondary culture with theophylline (Th) rather than adding it during 
                IPTG induction resulted in an increased protein yield. <br></br>
                The presence of double bands in protein profiles can be attributed to various factors, such as 
                post-translational modifications, alternative splicing, partial protein degradation, 
                cross-reactivity of the antibody, or issues related to gel electrophoresis.
                </p>

                <div class="result-centered">
                  <figure>
                    <img
                      id="Figure1_SpaC"
                      src="https://static.igem.wiki/teams/4888/wiki/result/western-plot-spac.png"
                      alt="results western blot spac"
                      class="result-image"
                      style={{ width: "50%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 1:</u>{" "}
                      </b>
                      Western blot analysis of SDS-boiled bacteria. The left panel displays bacteria subjected to 
                      protein induction at 18°C overnight, while the right panel shows induction at 37°C for 2 
                      hours. 'Early induction' refers to the addition of theophylline (Th) to the medium during 
                      the launch of the secondary culture, while 'late induction' indicates simultaneous addition 
                      of Th and IPTG. Remaining bands were induced using either Th, IPTG, or no inducer.
                    </figcaption>
                  </figure>
                </div>                

                <p className="mb-2">
                  <u><b>Conclusions:</b></u><br></br>
                  Inducing protein expression at 37°C exhibited superior control. Consequently, for subsequent 
                  experiments, the SpaC construct was induced at 37°C for a duration of two hours. To ensure a 
                  robust signal, theophylline was consistently introduced at the initiation of secondary cultures. <br></br>
                  To address the issue of the blurry and less distinct Western blot, we used sonication as a 
                  method to extract proteins, with the aim of achieving cleaner and more precise readouts.             
                </p>

          

          </div>
          <div>{/*Surface Expression */}
            <h3 className="mt-10 mb-5" id="Surface_Display_SpaC_s">Surface display of SpaC: </h3>
              <div>{/*IF*/}
                <h4 className="mb-2" >Immunofluorescence (IF) analysis SpaC: </h4>
                  <p className="mb-20">

                  Numerous unsuccessful methods were attempted before resorting to the IF assay. Detailed results 
                  and explanations can be found in the '<a href="#What_did_go_wrong_SpaC_s">What went wrong</a>' section 
                  located at the bottom of the page.<br></br>
                  Two fixation protocols were applied, one employing fixation based on ethanol, the other based 
                  on formaldehyde. Surface expression would manifest as signal overlap between bacteria, as 
                  indicated by DAPI staining, and the fluorescent signal from the secondary antibody.<br></br>
                  While the negative control (EC20) showed no response to anti-Flag antibody incubation, there 
                  were observable signals for SpaC (<a href="#Figure2_SpaC">Figure 2</a>). However, these signals 
                  did not align with the DAPI signals marking bacterial positions. On the contrary, the signal was 
                  stronger for the areas without bacteria. <br></br>
                  Formaldehyde fixation also produced negative results (<a href="#Figure3_SpaC">Figure 3</a>), 
                  with the negative control exhibiting a stronger signal than the SpaC expressing strain.
                  </p>

                  <div class="result-centered">
                    <figure>
                    <div class='result-div'>{/**Ethanol */}
                      <img
                          id="Figure2_SpaC"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-failed-ethanol-spac.jpg"
                          alt="results if ethanol spac"
                          class="result-image"
                          style={{ width: "100%" }}
                      />
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 2:</u>{" "}
                        </b>
                        Ethanol-fixed sample with anti-Flag antibody staining. Blue: DAPI stain, green: Flag-tag. 
                        Testing sample: SpaC-hosting bacteria, negative control: EC20-hosting bacteria.
                      </figcaption>
                    </div>
                    <div class='result-div'>{/**Formaldehyde */}
                      <img
                        id="Figure3_SpaC"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-failed-formaldehyde-spac.jpg"
                        alt="results if formaldehyde spac"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 3:</u>{" "}
                        </b>
                        Formaldehyde-fixed sample with anti-Flag antibody staining. Blue: DAPI stain, green: 
                        Flag-tag. Testing sample: SpaC-hosting bacteria, negative control: EC20-hosting bacteria.
                      </figcaption>
                    </div>
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    The lack of positive results could be due to issues with our experiment setup, problems with 
                    how the antibody attaches, or because SpaC might not be showing up on the surface as expected. 
                    We saw the antibody working in our Western blots, and we followed a standard procedure, so we 
                    thought that the reason for the lack of signal might be that SpaC, being a large protein, is 
                    not displayed properly on the surface.<br></br>
                    We relied on the insights from Kant et al. (2020) to pinpoint the domains in our construct 
                    responsible for mucus binding{" "}<a href="#reference3_SpaC">{" "}<sup>3</sup>{" "}</a>. 
                    Our next course of action was to employ various cloning methods to remove the stalk portion of 
                    SpaC, reducing it to just its binding domains.                
                  </p>
              </div>

          </div>
          
        <h2 className="mt-20" id="D1D2_D2_results_s">D1D2 & D2: </h2>
        <hr className="dividergeneral mb-5" />
          <div>{/*Cloning */}
            <h3 className="mt-10 mb-5" id="Cloning_truncated_s">Cloning of the truncated protein: </h3>
            <div>{/*PCR*/}
                <h4 className="mb-2" id="Cloning_D2">Cloning of D2: </h4>
                  <p className="mb-20">
                    The first step in our cloning process was to create copies of the required fragments using a 
                    PCR reaction. Both the D2 fragment and the corresponding backbone were successfully amplified, 
                    displaying signals at the expected lengths of 765 bp and 4315 bp, respectively 
                    (<a href="#Figure1_D1D2">Figure 1</a> and <a href="#Figure2_D1D2">2</a>).<br></br>
                    To carry out a HiFi cloning reaction and connect the two fragments, homology arms (HA) were 
                    added to the D2 fragment in a second PCR reaction (<a href="#Figure3_D1D2">Figure 3</a>). <br></br>
                    D2 was introduced into the backbone and bacteria were successfully transformed.
                  </p>

                  <div class="result-centered">
                    <figure>
                      <div class='result-div-three'>{/**D2*/}
                        <img
                          id="Figure1_D1D2"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/cloning-pcr-d2.jpg"
                          alt="results pcr d2"
                          class="result-image"
                          style={{ width: "100%" }}
                        />                   
                      </div>
                      <div class='result-div-three'>{/**backbone*/}
                        <img
                          id="Figure2_D1D2"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/cloning-pcr-backbone.jpg"
                          alt="results pcr backbone"
                          class="result-image"
                          style={{ width: "100%" }}
                        />                      
                      </div>
                      <div class='result-div-three'>{/**D2 + HA*/}
                        <img
                          id="Figure3_D1D2"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/cloning-pcr-d2-ha.jpg"
                          alt="results pcr d2 ha"
                          class="result-image"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div class='result-div-three'>{/**D2 caption*/}                        
                        <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 1:</u>{" "}
                          </b>
                          Agarose gel electrophoresis of PCR amplification for the D2 fragment.
                        </figcaption>                    
                      </div>
                      <div class='result-div-three'>{/**backbone caption*/}
                        <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 2:</u>{" "}
                        </b>
                        Agarose gel electrophoresis of PCR amplification for the backbone fragment.
                      </figcaption>
                      
                      </div>
                      <div class='result-div-three'>{/**D2 + HA caption*/}                    
                        <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 3:</u>{" "}
                        </b>
                        Agarose gel electrophoresis of PCR amplification of the D2 fragment with introduced 
                        homology arms (HA).
                        </figcaption>
                      </div>
                    </figure>
                  </div>
                <h4 className="mb-2" id="Cloning_D1D2_s">Cloning of D1D2: </h4>
                  <p className="mb-2">
                  We amplified the vector fragment containing the D1D2 construct using PCR, resulting in a 
                  fragment of the expected size, 8620 bp (<a href="#Figure4_D1D2">Figure 4</a>). Subsequently, 
                  fragment ends were joined in a KLD cloning reaction, and we successfully transformed bacteria 
                  with the obtained plasmid.
                  </p>

                  <div class="result-centered">
                    <figure>
                      <img
                        id="Figure4_D1D2"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/cloning-pcr-d1d2-vector.jpg"
                        alt="results pcr vector d1d2"
                        class="result-image"
                        style={{ width: "40%" }}
                      />                      
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 4:</u>{" "}
                        </b>
                        Agarose gel electrophoresis of PCR amplification for the vector fragment for D1D2.
                      </figcaption>
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    Cloning and transformation were successful for both constructs, allowing us to proceed with 
                    experiments assessing expression.               
                  </p>
            </div>
            <div>{/*Sequencing*/}
                <h4 className="mb-2" id="sequencing_D2-D1D2_s">Sequencing of D2 and D1D2: </h4>
                  <p className="mb-20">
                  We confirmed the integrity of our new plasmids through sequencing.<br></br>
                  <a href="#Figure5_later">Figure 5</a> presents the sequencing results for D2, which matched our 
                  construct. Some mismatches at the fragment borders were observed, which is standard.<br></br>
                  In <a href="#Figure6_later">Figure 6</a> and <a href="#Figure77"> 7 </a>, we present the 
                  sequencing results for D1D2. The sequencing data revealed a missing nucleotide in the stop 
                  codon, resulting in an additional 10 amino acids at the C-terminal of the resulting construct. 
                  As for D2, there were the standard mismatches at the fragment borders.
                  </p>

                  <div class="result-centered">{/*D2 */}
                    <figure>
                      <img
                        id="Figure5_later"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/cloning-hifi-d2.jpg"
                        alt="results pcr d2"
                        class="result-image"
                        style={{ width: "70%" }}
                      />
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 5:</u>{" "}
                        </b>
                        MicroSynth sequencing results for the plasmid containing the D2-construct after HiFi 
                        cloning. Red lines indicate errors.
                      </figcaption>
                    </figure>
                  </div>
                  <div class="result-centered">{/*D1D2 */}
                    <figure>
                    <div class='result-div'>
                      <img
                        id="Figure6_later"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/cloning-kld-d1d2-1.jpg"
                        alt="results expression ponceau s d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 6:</u>{" "}
                        </b>
                        MicroSynth sequencing results for the plasmid containing the D1D2-construct after KLD 
                        cloning. Red lines indicate errors.
                      </figcaption>
                      </div>
                      <div class='result-div'>
                        <div ></div>
                      <img
                        id="Figure77"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/cloning-kld-d1d2-zoom.jpg"
                        alt="results expression western d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 7:</u>{" "}
                        </b>
                        Zoom on nucleotide loss in MicroSynth sequencing results for the plasmid containing the 
                        D1D2-construct after KLD cloning. Red lines indicate errors.
                      </figcaption>
                      </div>                                            
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    The cloning of D2 was successful. In the case of D1D2, an additional 10 amino acids were 
                    unintentionally incorporated, but we still proceeded with the resulting construct.             
                  </p>
            </div>
          </div>
          <div>{/*Expression */}
            <h3 className="mt-10 mb-5" id="Expression_D1D2_s">Expression: </h3>
            <div>{/*Expression conditions*/}
                <h4 className="mb-2" id="Expression1_D1D2_s">The expression of D2 and D1D2 under specific conditions: </h4>
                  <p className="mb-20">
                  We examined the expression of D2 and D1D2 under specific conditions (IPTG, theophylline, 
                  neither, both). D1D2 (<a href="#Figure6_D1D2">Figure 9</a>) and D2 (<a href="#Figure8_D1D2">Figure 11</a>) 
                  displayed the highest protein expression levels when induced with both. The observed bands 
                  matched the anticipated sizes of around 80 kDa for D1D2 and 57 kDa for D2. Notably, IPTG or 
                  theophylline alone still led to modest level of protein expression, indicating that both 
                  expression systems have some degree of leakiness. However, in the absence of both inducers, 
                  D2 expression was completely inhibited, and D1D2 expression was minimal.<br></br>
                  In contrast, the original SpaC construct (<a href="#Figure9_D1D2">Figure 12</a>) displayed 
                  leakiness exclusively with respect to the lac promoter, as the theophylline switch maintained 
                  precise regulation.
                  </p>

                  <div class="result-centered">{/*Figures */}
                    <figure>
                      <div>{/*D1D2*/}
                        <div class='result-div'>{/**Poneau S*/}
                          <img
                            id="Figure5_D1D2"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-d1d2-ponceau-s.jpg"
                            alt="results expression ponceau s d1d2"
                            class="result-image"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div class='result-div'>{/**Western*/}
                          <img
                            id="Figure6_D1D2"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-d1d2-western.jpg"
                            alt="results expression ponceau s d1d2"
                            class="result-image"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div class='result-div'>{/**Poneau S Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 8:</u>{" "}
                          </b>
                          Loading control (Ponceau S staining) for Western blot of D1D2 construct-expressing 
                          bacteria under various induction conditions (theophylline, IPTG, both, or neither).
                          </figcaption>
                        </div>
                        <div class='result-div'>{/**Western Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 9:</u>{" "}
                          </b>
                          Western blot analysis of boiled bacteria hosting the D1D2 construct, induced with 
                          theophylline (Th), IPTG, both, or neither.
                          </figcaption>
                        </div>
                      </div>
                      <div>{/*D2*/}
                        <div class='result-div'>{/**Poneau S*/}
                          <img
                            id="Figure7_D1D2"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-d2-ponceau-s.jpg"
                            alt="results expression ponceau s d1d2"
                            class="result-image"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div class='result-div'>{/**Western*/}
                          <img
                            id="Figure8_D1D2"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-d2-western.jpg"
                            alt="results expression ponceau s d1d2"
                            class="result-image"
                            style={{ width: "100%" }}
                          />
                        </div>                        
                        <div class='result-div'>{/**Poneau S Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 10:</u>{" "}
                          </b>
                          Loading control (Ponceau S staining) for Western blot of D2 construct-expressing 
                          bacteria under various induction conditions (theophylline, IPTG, both, or neither).
                          </figcaption>
                        </div>
                        <div class='result-div'>{/**Western Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 11:</u>{" "}
                          </b>
                          Western blot analysis of boiled bacteria hosting the D2 construct, induced with 
                          theophylline (Th), IPTG, both, or neither.
                          </figcaption>
                        </div>
                      </div>
                      <div>{/*SpaC*/}
                        <div class='result-div'>{/**Poneau S*/}
                          <img
                            id="Figure9_D1D2"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-spac-ponceau-s.jpg"
                            alt="results expression ponceau s d1d2"
                            class="result-image"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div class='result-div'>{/**Western*/}
                          <img
                            id="Figure10_D1D2"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-spac-western.jpg"
                            alt="results expression ponceau s d1d2"
                            class="result-image"
                            style={{ width: "100%" }}
                          />
                        </div>                        
                        <div class='result-div'>{/**Poneau S Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 12:</u>{" "}
                          </b>
                          Loading control (Ponceau S staining) for Western blot of SpaC construct-expressing 
                          bacteria under various induction conditions (theophylline, IPTG, both, or neither).
                          </figcaption>
                        </div>
                        <div class='result-div'>{/**Western Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 13:</u>{" "}
                          </b>
                          Western blot analysis of boiled bacteria hosting the SpaC construct, induced with 
                          theophylline (Th), IPTG, or neither.
                          </figcaption>
                        </div>
                      </div>
                    </figure>
                  </div>



                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    We successfully induced protein expression. We note that neither expression system is 
                    completely tight individually, but their combination minimizes leakiness. Our next goal 
                    was to investigate the duration of protein persistence on the bacterial surface.                
                  </p>
            </div>
            <div>{/*Surface Expression*/}
            <h3 className="mt-10 mb-5" id="Surface_Expression_D1D2_s">Surface expression of D2 and D1D2: </h3>
                <h4 className="mb-2" id="Surface_Expression_D1D2_s">Immunofluorescence (IF) analysis D2 and D1D2: </h4>
                  <p className="mb-20">
                  Bacteria were fixed using paraformaldehyde and a permeabilization condition was introduced using 
                  tween20, a membrane-disrupting detergent.<br></br>
                  In <a href="#Figure11_D1D2">Figure 14</a>, induced bacteria hosting the D1D2-construct exhibited 
                  strong signal for the His-tag detection, aligning precisely with HOECHST-stained bacterial 
                  positions. In contrast, <a href="#Figure12_D1D2">Figure 15</a>, showing uninduced bacteria 
                  (negative control), displayed no fluorescent signal for the His-tag.<br></br>
                  The same pattern was observed for the D2-construct in <a href="#Figure13_D1D2">Figure 16 </a> 
                  (induced) and <a href="#Figure14_D1D2">17</a> (uninduced).<br></br>
                  The fluorescence signal intensity was quantified for 20 individual bacteria in each condition 
                  and summarized in a boxplot (<a href="#Figure15_D1D2">Figure 18</a> and <a href="#Figure16_D1D2">19</a>). 
                  Statistical significance, indicating differences in means, was determined using a two-tailed 
                  unequal variance student's t-test. The obtained p-values were very low, indicating statistical 
                  significance. <br></br>
                  The signal intensity of permeabilized bacteria was significantly lower than that of untreated 
                  bacteria for both constructs. This discrepancy could be attributed to potential protein losses 
                  from the bacterial surface during tween20 treatment.<br></br>
                  Though less probable, a shorter incubation time of permeabilized bacteria with the primary 
                  antibody could potentially contribute to the lower signal. While the treated samples were 
                  incubating with tween20 for 1.5 hours, the untreated samples were already undergoing incubation 
                  with the primary antibody.
                  </p>

                  <div class="result-centered">{/*D1D2 */}
                    <figure>
                    <div class='result-div'>
                      <img
                        id="Figure11_D1D2"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-final-d1d2.jpg"
                        alt="results expression ponceau s d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 14:</u>{" "}
                        </b>
                        Paraformaldehyde-fixed D1D2-construct expressing bacteria. HOECHST stain in blue for DNA 
                        visualization, and anti-Flag antibody stain in red.
                      </figcaption>
                      </div>
                      <div class='result-div'>
                      <img
                        id="Figure12_D1D2"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-final-d1d2-negative-control.jpg"
                        alt="results expression western d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 15:</u>{" "}
                        </b>
                        Paraformaldehyde-fixed uninduced D1D2-construct hosting bacteria as negative control. 
                        HOECHST stain in blue for DNA visualization, and anti-Flag antibody stain in red.
                      </figcaption>
                      </div>
                      
                      
                    </figure>
                  </div>
                  <div class="result-centered">{/*D2 */}
                    <figure>
                      <div class='result-div'>
                        <img
                          id="Figure13_D1D2"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-final-d2.jpg"
                          alt="results expression ponceau s d1d2"
                          class="result-image"
                          style={{ width: "100%" }}
                        />
                        <br></br>
                        <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 16:</u>{" "}
                          </b>
                          Paraformaldehyde-fixed D2-construct expressing bacteria. HOECHST stain in blue for DNA 
                          visualization, and anti-Flag antibody stain in red.
                        </figcaption>
                        </div>
                        <div class='result-div'>
                        <img
                          id="Figure14_D1D2"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-final-d2-negative-control.jpg"
                          alt="results expression western d1d2"
                          class="result-image"
                          style={{ width: "100%" }}
                        />
                        <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 17:</u>{" "}
                          </b>
                          Paraformaldehyde-fixed uninduced D2-construct hosting bacteria as negative control. 
                          HOECHST stain in blue for DNA visualization, and anti-Flag antibody stain in red.
                        </figcaption>
                      </div>
                      </figure>
                  </div>
                  <div class="result-centered">{/*Box Plots */}
                    <figure>
                    <div class='result-div'>
                      <img
                        id="Figure15_D1D2"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-final-blot-plot-d1d2.jpg"
                        alt="results"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 18:</u>{" "}
                        </b>
                        Boxplots illustrating the intensity measures of the immunofluorescence (IF) signals for 
                        various conditions. 'Surface D1D2' represents D1D2 construct-expressing bacteria on the 
                        surface, 'Negative control' refers to uninduced D1D2 construct-hosting bacteria, and 
                        'Permeabilized D1D2' indicates induced D1D2 construct-carrying bacteria that have been 
                        permeabilized. Statistical significance was determined using a two-tailed unequal variance 
                        student's t-test (***: p-value&lt;0.001).
                      </figcaption>
                    </div>
                    <div class='result-div'>
                    <img
                      id="Figure16_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-final-blot-plot-d2.jpg"
                      alt="results expression western d1d2"
                      class="result-image"
                      style={{ width: "100%" }}
                    />
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 19:</u>{" "}
                      </b>
                      Boxplots illustrating the intensity measures of the immunofluorescence (IF) signals for 
                      various conditions. 'Surface D2' represents D2 construct-expressing bacteria on the surface, 
                      'Negative control' refers to uninduced D2 construct-hosting bacteria, and 'Permeabilized D2' 
                      indicates induced D2 construct-carrying bacteria that have been permeabilized. Statistical 
                      significance was determined using a two-tailed unequal variance student's t-test 
                      (*** : p-value&lt;0.001, ** : p-value&lt;0.01).
                    </figcaption>
                    </div>
                      
                      
                    </figure>
                  </div>
                  <div class="result-centered">{/*Box Plots */}
                    <figure>
                      <Figure17/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>p-values D1D2:</u>{" "}
                        </b>
                        The p-values were calculated using a two-tailed unequal variance student's t-test. 
                        The comparison was made among three different samples: surface expressed D1D2, 
                        permeabilized D1D2, and uninduced D1D2 (negative control).
                      </figcaption>
                      <Figure16/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>p-values D2:</u>{" "}
                        </b>
                        The p-values were calculated using a two-tailed unequal variance student's t-test. 
                        The comparison was made among three different samples: surface expressed D2, 
                        permeabilized D2, and uninduced D2 (negative control).
                      </figcaption>
                      
                      
                    </figure>
                  </div>
                      
                      

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    The IF showed that both D2 and D1D2 are expressed and displayed at the surface of the bacteria.              
                  </p>
            </div>
          </div>
          <div>{/*Half-Life */}
           <h3 className="mt-10 mb-5" id="Half_Life_D1D2_s">Half-life: </h3>
            <div>{/*Half-life*/}
                <h4 className="mb-2" id="Half_Life_Assessment_D1D2_s">Assessment of half-life for D2 and D1D2: </h4>
                  <p className="mb-20">
                  The bacteria were boiled at specific time points following the induction of their respective 
                  constructs. Signal intensities on the Western blots (<a href="#Figure11_D1D2_">Figure 20</a> and  
                  <a href="#Figure12_D1D2_"> 21</a>) were quantified using Fiji (<a href="#Figure16_D1D2_">Figure 22 </a> 
                  and <a href="#Figure17_D1D2_">23</a>), and standard curves were generated in Excel 
                  (<a href="#Graph1_D1D2">Graph 1</a> and <a href="#Graph2_D1D2"> 2</a>). By applying the equation 
                  derived from the standard curve, we determined a half-life of 119.5 hours (5 days) for D2 and 
                  113 hours (4.7 days) for D1D2.
                  </p>

                  <div class="result-centered">{/*D1D2 Poneau + Western */}
                    <figure>
                      <img
                        id="Figure11_D1D2_"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/half-life-d1d2-ponceau-western.jpg"
                        alt="results half life d1d2 ponceau s "
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 20:</u>{" "}
                        </b>
                        Loading control (Ponceau S staining) on the left and corresponding Western blot on the 
                        right, showing D1D2 construct-expressing bacteria at various time points after induction.
                      </figcaption>
                    </figure>
                  </div> 
                  <div class="result-centered">{/*D2 Poneau + Western */}
                    <figure>
                      <img
                        id="Figure12_D1D2_"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/half-life-d2-ponceau-western.jpg"
                        alt="results half life d1d2 ponceau s "
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 21:</u>{" "}
                        </b>
                        Loading control (Ponceau S staining) on the left and corresponding Western blot on the 
                        right, showing D2 construct-expressing bacteria at various time points after induction.
                      </figcaption>
                    </figure>
                  </div> 

                  <div class="result-centered">{/*Figures */}
                    <figure>
                      <div>{/*Plots*/}
                        <div class='result-div'>{/**D1D2*/}
                          <img
                          id="Figure16_D1D2_"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/half-life-d1d2-plot-signals.jpg"
                          alt="results half life d1d2 signal plot"
                          class="result-image"
                          style={{ width: "100%" }}
                          />
                        </div>
                        <div class='result-div'>{/**D2*/}
                          <img
                            id="Figure17_D1D2_"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/half-life-d2-plot-signals.jpg"
                            alt="results expression ponceau s d1d2"
                            class="result-image"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div class='result-div'>{/**D1D2 Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 22:</u>{" "}
                          </b>
                          Quantifying the signal intensities of the different bands from the Western blot of the 
                          D1D2 construct using Fiji software; the numerical values represent the areas of the 
                          distinct signals.
                          </figcaption>
                        </div>
                        <div class='result-div'>{/**D2 Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Figure 23:</u>{" "}
                          </b>
                          Quantifying the signal intensities of the different bands from the Western blot of the D2 
                          construct using Fiji software; the numerical values represent the areas of the distinct 
                          signals.
                          </figcaption>
                        </div>
                      </div>

                      <div>{/*Curves*/}
                        <div class='result-div'>{/**D1D2*/}
                          <img
                          id="Graph1_D1D2"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/half-life-plot-matlab-d1d2.jpg"
                          alt="results half life d1d2 signal plot"
                          class="result-image"
                          style={{ width: "100%" }}
                          />
                        </div>
                        <div class='result-div'>{/**D2*/}
                          <img
                            id="Graph2_D1D2"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/half-life-plot-matlab-d2.jpg"
                            alt="results expression ponceau s d1d2"
                            class="result-image"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div class='result-div'>{/**D1D2 Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Graph 1:</u>{" "}
                          </b>
                          Standard intensity curve generated from experimental data of the D1D2 construct Western blot.
                          </figcaption>
                        </div>
                        <div class='result-div'>{/**D2 Caption*/}
                          <figcaption className="mt-2 mb-10">
                          <b>
                            <u>Graph 2:</u>{" "}
                          </b>
                          Standard intensity curve generated from experimental data of the D2 construct Western blot.
                          </figcaption>
                        </div>
                      </div>
                    </figure>
                  </div>                
  

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    We determined that the observed half life our of constructs were approximately 5 days. This 
                    was ideal for our purposes, because if mucus turnover is slow or if undesired binding occurs 
                    elsewhere in the body because of our anchoring construct, the protein's inherent degradation 
                    will guarantee its removal within a few days.<br></br>
                    The following sections described our mucus binding experiments. 
                  </p>
              </div>

          </div>
          <div>{/*Mucus-Binding */}
           <h3 className="mt-10 mb-5" id="Mucus_Binding_D1D2_s">Mucus-binding: </h3>
            <div>{/*First Experiment*/}
                <h4 className="mb-2" id="Mucus_Binding1_D1D2_s">First mucus-binding experiment: </h4>
                  <p className="mb-2">
                  To assess the binding capacity of our live biotherapeutic product (LBP), we conducted a mucus 
                  binding experiment following a detailed protocol. Surprisingly, despite adhering to the 
                  protocol's instructions and using the specified concentration (Optical Density OD600) of 
                  bacterial culture for incubation on mucus, we observed no colony growth on the plates.<br></br>
                  Upon investigating the issue, we collaborated with the Sofya Mikhaleva from the Alexandre Persat 
                  lab at EPFL, to measure the OD of our bacterial culture. This investigation revealed that our lab's 
                  OD machine provided inaccurate readings, consistently overestimating the OD values by a factor of 4 
                  to 6. Consequently, our bacterial concentrations were significantly lower than those intended by 
                  the protocol.<br></br>
                  These erroneous OD readings also led to a misjudgement in the timing of our induction. Instead 
                  of inducing at an OD of 0.4, as recommended, we inadvertently induced at an OD of around 2.4.
                  </p>                

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    We plan to replicate the experiment using a dependable OD meter to ensure accurate bacterial 
                    density measurements. This will enable us to induce D2 and D1D2 expression at the correct 
                    time points and work with the optimal bacterial concentration for the mucus binding experiment.<br></br>
                    In the upcoming experiment, we will assess the colony-forming capacity of the different 
                    bacterial strains. If we observe any issues related to their fitness, we may consider working 
                    with higher bacterial densities to compensate for the potential loss of bacteria that are 
                    unable to form colonies.
                  </p>
              </div>
            <div>{/*Second Experiment*/}
              <h4 className="mb-2" id="Mucus_Binding2_D1D2_s">Second mucus-binding experiment: </h4>
                <p className="mb-20">
                The mucus binding experiment was repeated with a functioning OD meter. Regrettably, even with the 
                accurate OD measurements, the mucus incubation still did not result in the growth of any colonies 
                (<a href="#Figure17_D1D2">Figure 24</a>). Interestingly, when we plated bacteria from the initial 
                solutions to assess their colony-forming capacity, we observed significant differences not only 
                in the number of colonies between the bacterial strains, but also in their phenotype 
                (<a href="#Figure20_D1D2">Figure 25</a>). While the induced bacterial strains had a significantly 
                lower colony count compared to the negative control (SpaC), their individual colonies were 
                notably larger in size.
                </p>

                <div class="result-centered">
                  <figure>
                    <img
                      id="Figure17_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/mucus-binding-experiment-1-d1d2-d2-spac-plating.jpg"
                      alt="results first mucus binding d1d2"
                      class="result-image"
                      style={{ width: "100%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 24:</u>{" "}
                      </b>
                      D1D2-expressing bacteria, harvested from the mucus or from the non-mucus-producing Caco2 
                      cells (negative control), and plated at different dilutions, 1:100 (10^2), 1:1000 (10^3), 
                      and 1:10000 (10^4), followed by overnight incubation. Bacteria were expressing either the 
                      D1D2-construct (left), D2-construct (middle), or no protein (uninduced SpaC – right). 
                    </figcaption>
                  </figure>
                </div>
                <div class="result-centered">
                  <figure>
                    <img
                      id="Figure20_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/mucus-binding-experiment-1-viability.jpg"
                      alt="results first mucus binding viability"
                      class="result-image"
                      style={{ width: "60%" }}
                    />                    
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 25:</u>{" "}
                      </b>
                      Colonies grown from the initial bacteria solutions that were standardized to an OD of 0.5, 
                      for the strains hosting D2, D1D2, or SpaC. The initial solution is diluted 1:100 and 1:1,000.
                    </figcaption>                    
                  </figure>
                </div>

                <p className="mb-2">{/*Outlook */}
                  <u><b>Conclusions:</b></u><br></br>
                  To successfully conduct the experiment, it was essential to have a control strain with a 
                  comparable colony count and phenotype to the strains being tested. If either theophylline or 
                  IPTG alone was sufficient for the observed changes in phenotype, we could use the inducer to 
                  mimic this phenotype in the negative control SpaC. Since the other critical inducer would be 
                  absent, there would still be no protein expression. We therefore planned to carry out an 
                  experiment that aimed to mimic  the phenotype of the test strain in the control strain.               
                </p>
              </div>
            <div>{/*Reproducing phenotype*/}
              <h4 className="mb-2" id="Reproduce_pheonotype_s">Reproduce phenotype of the test strains D2 and D1D2: </h4>
                <p className="mb-20">
                The purpose of this experiment was to replicate the previously observed appearance of the induced 
                testing strain in SpaC-construct hosting bacteria, creating a more dependable negative control for 
                the subsequent mucus binding test.<br></br>
                We compared all our bacterial strains grown in theophylline, IPTG, and neither with those 
                expressing D2 and D1D2.
                Induced bacteria hosting the D2 and D1D2 constructs exhibited a significantly reduced colony count (<a href="#Figure21_D1D2">Figure 26</a>).
                This phenotype appeared to be triggered by the presence of IPTG, which is consistent with the 
                observation in the SpaC strain when induced with IPTG alone (<a href="#Figure24_D1D2">Figure 27</a>). 
                Theophylline alone did not result in a reduced colony count.<br></br>
                These findings suggest that induction with IPTG might lead to transcriptional stress, either 
                reducing the viability of induced bacteria or hampering cellular division to the extent that 
                detectable colonies no longer form from a large fraction of single bacteria.<br></br>
                Additionally, the observed phenotype of fast-growing colonies appeared to be associated with the 
                truncated constructs themselves rather than the induction of protein expression, as indicated by 
                the difference in colony size between the D2 and D1D2 strains compared to the SpaC strain.<br></br>
                It was also noteworthy that the size of the D2 and D1D2 colonies was consistently larger than 
                those of SpaC, regardless of the conditions. This size difference is intriguing, considering that 
                all three constructs were introduced into BL21 bacteria. 
                </p>

                <div class="result-centered">
                  <figure>
                    <img
                      id="Figure21_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-assay-mucus-binding-d1d2-d2-final-x.jpg"
                      alt="results viability assay d1d2"
                      class="result-image"
                      style={{ width: "100%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 26:</u>{" "}
                      </b>
                      Agar plate of bacteria expressing D1D2 and D2 constructs under different conditions: 
                      theophylline (Th), theophylline + IPTG (IPTG + Th), and negative control (NC). Left plate: 
                      Bacteria expressing D1D2 for NC, IPTG + Th, and Th. Middle plate: Bacteria 
                      expressing D1D2 for Th and bacteria expressing D2 for IPTG. Right plate: Bacteria expressing 
                      D2 for NC, IPTG + Th, and Th.
                    </figcaption>
                    <img
                      id="Figure24_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-assay-mucus-binding-spac.jpg"
                      alt="results viability assay spac"
                      class="result-image"
                      style={{ width: "50%" }}
                    />
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 27:</u>{" "}
                      </b>
                      Agar plate of bacteria hosting SpaC under different conditions: IPTG, theophylline (Th), and 
                      negative control (NC).
                    </figcaption>
                  </figure>
                </div>

                <p className="mb-2">{/*Outlook */}
                  <u><b>Conclusions:</b></u><br></br>
                  Moving forward, we will employ IPTG-induced bacteria hosting the SpaC construct as our negative 
                  control. Subsequent experiments will be undertaken to determine appropriate dilutions for 
                  SpaC-hosting bacteria and induced D2 & D1D2 strains to achieve a similar number of colonies 
                  per volume of spread culture.               
                </p>
              </div>
            <div>{/*Find Concentration for D1D2*/}
              <h4 className="mb-2" id="Find_optimal_concentration_s">Find appropriate dilutions for D1D2 and D2: </h4>
                <p className="mb-2">
                Following the viability assay experiment, we conducted tests using dilutions of OD=1 in addition 
                to 1:10 and 1:100 dilutions. It is crucial to emphasize that these dilutions have double the 
                number of bacteria in comparison to the corresponding dilutions in the previous experiment, as we 
                initiated with an OD=1 instead of an OD=0.5.<br></br>
                Our aim was to determine a concentration with a sufficient number of colonies that are also 
                easy to count. It appears that a 1:100 dilution from an OD=1 solution is suitable for D1D2, 
                while for D2, a 1:10 dilution from an OD=1 solution provides favourable outcomes.
                </p>

                <div class="result-centered">
                  <figure>                    
                    <img
                      id="Figure25_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/concentration-evalutation-d2-d1d2.jpg"
                      alt="results concentration mucus binding spac"
                      class="result-image"
                      style={{ width: "50%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 28:</u>{" "}
                      </b>
                      Agar plate of bacteria hosting D1D2 and D2 constructs plated at different dilutions of 1:1, 
                      1:10, and 1:100, with a starting OD of 1.
                    </figcaption>
                  </figure>
                </div>

                <p className="mb-2">{/*Outlook */}
                  <u><b>Conclusions:</b></u><br></br>
                  Now that we identified appropriate concentrations for the D2 and D1D2 strains, our next goal is 
                  to ascertain whether incubating SpaC-construct hosting bacteria with IPTG will lead to a 
                  similar colony density when plated at the same optical density (OD). This research is crucial 
                  because it will enable us to load bacteria at a concentration that produces a manageable number 
                  of colonies for accurate counting, allowing a meaningful comparison between the strains.<br></br>               
                </p>
              </div>
            <div>{/*Find Concentration for SpaC*/}
              <h4 className="mb-2" id="Find_Concentration_SpaC_s">Determination of suitable dilution for SpaC as negative control: </h4>
                <p className="mb-20">
                SpaC-hosting bacteria incubated with IPTG will function as our control for the mucus binding assay. 
                The objective of this experiment was to identify an appropriate dilution for the negative control 
                that results in a comparable number of colonies to the testing strains.<br></br>
                In line with our earlier discoveries, we examined dilutions of 1:1, 1:10, and 1:100.<br></br>
                We were advised that the change in phenotype of the induced strain might be connected to a decline 
                in antibiotic resistance. To explore this possibility, we replicated the experiment once on a 
                KAN plate and once on a plate without antibiotics. This aspect was worth investigating because if 
                antibiotics are indeed responsible for the low colony count, we could potentially substitute the 
                antibiotic-containing plates with neutral ones and employ any BL21 bacterial strain as a negative 
                control.<br></br>
                Upon comparing conditions on <a href="#Figure26_D1D2">Figure 29</a>, we found no substantial 
                difference between the presence and absence of Kanamycin. The 1:10 dilution remained the most 
                suitable choice for the D2-expressing bacteria, consistent with previous findings. Additionally, 
                we noticed that SpaC, even when incubated with IPTG, continued to yield a significantly higher 
                colony count than the D2-expressing cells. Remarkably, the 1:100 dilution of SpaC displayed a 
                colony count similar to the undiluted D2 solution (<a href="#Figure26_D1D2">Figure 29</a>). As a 
                result, for forthcoming experiments, our plan was to dilute SpaC-hosting bacteria by a factor of 
                100 compared to the testing strains.
                </p>

                <div class="result-centered">
                  <figure>
                    <img
                      id="Figure26_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/antibiotics-reducing-colony-count.jpg"
                      alt="results concentration spac kan"
                      class="result-image"
                      style={{ width: "80%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 29:</u>{" "}
                      </b>
                      Agar plate of bacteria hosting SpaC (Sp, S) and D2 constructs plated at different dilutions 
                      (1:1, 1:10, and 1:100) with an initial OD of 0.1. In the presence of kanamycin (left) and 
                      in the absence of kanamycin (right).
                    </figcaption>
                  </figure>
                </div>

                <p className="mb-2">{/*Outlook */}
                  <u><b>Conclusions:</b></u><br></br>
                  After this set of experiments, we decided to repeat the mucus-binding experiment using 
                  SpaC-hosting bacteria incubated with IPTG as our negative control. Furthermore, we decided to 
                  dilute the negative control strain by a factor of 100 in comparison to the testing strains. 
                  These experiments are described in the following sections.                
                </p>
              </div>
            <div>{/*Third Experiment*/}
              <h4 className="mb-2" id="Third_Experiment_D1D2_s">Third mucus-binding experiment: </h4>
                <p className="mb-20">
                We repeated the mucus binding experiment with duplicate experiments for increased robustness. 
                As observed in Figures <a href="#Figure28_D1D2">Figure 30</a> and <a href="#Figure29_D1D2">31</a>, 
                SpaC-hosting bacteria continued to display a significantly higher colony count compared to the 
                induced bacteria.<br></br>
                To assess the binding capacity, we compared the number of colonies from the initial bacterial 
                solution with those obtained from bacteria harvested after mucus incubation, as shown in 
                <a href="#Table1_D1D2_1">Table 1</a>. In the case of the negative control, the post-mucus 
                incubation colony count was approximately 1% of the initial number. D1D2 hosting bacteria 
                exhibited percentages in the range of 24% to 40%, while D2-expressing bacteria ranged from 8% to 
                18%. However, it was important to note that the negative control with a 1:100 dilution and D2 
                hosting bacteria with a 1:10 dilution had very low colony counts, with only 1 and 2 colonies, 
                respectively, following mucus incubation. This limited count made the resulting percentages less 
                reliable, as minor variations in colony count can lead to substantial percentage changes.<br></br>
                Selecting only the most robust and conservative values (24% for D1D2, 8.6% for D2, and 1.4% for 
                negative control) we still observed an 18-fold increase in binding for D1D2-expressing bacteria 
                and a 6.3-fold increase in binding for D2-expressing bacteria compared to the negative control.<br></br>
                In the second replicate (<a href="#Table2_D1D2">Table 2</a>), the binding of the negative control 
                to the mucus was too low to quantify the difference, as the data was highly susceptible to random 
                variation. In the case of D2, the presence of a rupture in the membrane where the mucus was 
                cultivated hindered us from obtaining conclusive results. However, for D1D2, while the colony 
                count was lower in the second experiment compared to the first, it still exhibited a 6 times 
                higher count than the negative control from the first experiment.<br></br>
                Although we could not achieve a dependable quantification in the second experiment, it was clear 
                that, starting from a relatively high initial concentration, very few colonies developed after 
                mucus incubation in the case of the negative control. Conversely, D1D2-expressing bacteria, 
                despite their initially low concentration, produced a significant number of colonies, strongly 
                suggesting a superior binding capacity.
                </p>

                <div class="result-centered">{/*Initial Load */}
                  <figure>                    
                    <img
                      id="Figure28_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/mucus-binding-experiment-final-initial-loading.jpg"
                      alt="results thrid experiment initial load"
                      class="result-image"
                      style={{ width: "80%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 30:</u>{" "}
                      </b>
                      Prior to mucus incubation, bacterial solutions were plated at various dilutions: 1:1, 1:10, 
                      and 1:100 for D2 and D1D2 hosting bacteria, and 1:10 and 1:100 for the negative control. 
                      Experiment duplicate 1 is shown on the left agar plate, and experiment duplicate 2 on the 
                      right plate. The numbers at the bottom represent the colony counts for the respective lanes.
                    </figcaption>
                  </figure>
                </div>
                <div class="result-centered">{/*Result - SpaC, D2, D1D2 */}
                  <figure>
                    <img
                      id="Figure29_D1D2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/mucus-binding-experiment-final-result.jpg"
                      alt="results third experiment d1d2"
                      class="result-image"
                      style={{ width: "100%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 31:</u>{" "}
                      </b>
                      Bacteria were plated after mucus incubation. Dilutions 1:1, 1:10, and 1:100 were plated. 
                      Experiment duplicate 1 was on the left, and duplicate experiment 2 was on the right of each 
                      Agar plate. The numbers at the bottom represent the colony counts for the respective lanes.
                      Bacteria expressing D1D2-construct on the plate on the left, bacteria expressing D2-construct 
                      in the middle, and uninduced bacteria (negative control) hosting the SpaC-construct on the 
                      right.
                    </figcaption>
                  </figure>                  
                </div>
                <div class="result-centered">{/*Tables */}
                  <figure>
                    <div id="Table1_D1D2_1" ></div>
                    <Figure12 />
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Table 1:</u>{" "}
                      </b>
                      Experiment duplicate 1. Comparison of the number of colonies growing from the initial 
                      bacterial solution to the number of colonies after mucus incubation, presented as a 
                      percentage. For the negative control, we display dilutions of 1:10 and 1:100. For the 
                      induced testing strains, we provide dilutions of 1:1 and 1:10.
                    </figcaption>
                    <div id="Table2_D1D2"></div>
                    <Figure13/>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Table 2:</u>{" "}
                      </b>
                      Experiment duplicate 2. Comparison of the number of colonies growing from the initial 
                      bacterial solution to the number of colonies after mucus incubation, presented as a 
                      percentage. For the negative control, we display dilutions of 1:10 and 1:100. For the 
                      induced testing strains, we provide dilutions of 1:1 and 1:10.
                    </figcaption>
                  </figure>
                </div>

                <p className="mb-2">{/*Outlook */}
                  <u><b>Conclusions:</b></u><br></br>
                  The initial mucus binding experiment revealed an enhanced affinity of both D2 and 
                  D1D2-expressing bacteria for mucus compared to a negative control. Notably, the binding 
                  capacity was more pronounced for D1D2 than for D2. This difference in binding affinity may be 
                  attributed to the increased length of D1D2, potentially allowing it to reach deeper into the 
                  mucus, or to an enhanced binding capability conferred by the presence of the D1 domain, which 
                  could stabilize the binding domain D2 in a more favourable conformation.<br></br>
                  This study marks a significant accomplishment as it confirms the binding of our ligand binding 
                  tag (LBT) to mucus, thereby demonstrating the effectiveness of our suggested anchoring system.<br></br>
                  To the best of our knowledge, this represents the first instance of D2 and D1D2 being displayed 
                  on the surface of E. Coli bacteria, and the first demonstration of E. Coli binding to mucus 
                  relying on these proteins.               
                </p>
              </div>
          </div>


        <div>{/*What went wrong */}
          <h2 className="mt-20"id="What_did_go_wrong_SpaC_s">What went wrong: </h2>
          <hr className="dividergeneral mb-5" />
            <p className="mb-2">{/**Introduction */}
            In this paragraph will discuss the experiments that were attempted, but ultimately unsuccessful along 
            with the reasons for their failure.
            </p>
            <div>{/*Surface expression */}
              <h3 className="mt-10 mb-5" id="Surface_Expression_SpaC_s">Surface expression of SpaC: </h3>
              <div>{/*GFP Experiment */}
                <h4 className="mb-2" id="GFP_Experiment_SpaC_s">GFP experiment:</h4>
                <p className="mb-2">
                This experiment relies on the GFP-specific nanobody incorporated into the SpaC construct to 
                verify the presence of the protein on the bacterial surface.
                </p>
                <div>{/*OD Calibration*/}
                <h4 className="mb-2" id="OD_Calibration_SpaC_s">Calibration of the OD meter: </h4>
                  <p className="mb-20">
                    Initially, we validated the sensitivity of our available OD meter to detect fluorescent signals. 
                    This involved preparing a dilution series of GFP and measuring the signal upon excitation at 488 
                    nm with emission at 509 nm (<a href="#Table1_SpaC">Table 1</a>). <br></br>
                    Subsequently, we generated a standard curve depicting the fluorescence signal as a function of 
                    GFP concentration, revealing a linear relationship (<a href="#Figure4_SpaC">Figure 1</a>).
                  </p>

                  <div class="result-centered">
                    <figure>
                      <div  id="Table1_SpaC"></div>
                      <Figure1/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 1:</u>{" "}
                        </b>
                        OD meter signal for specified GFP concentrations.  
                      </figcaption>
                      <div id="Figure4_SpaC"></div>
                      <Figure2/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure: 1</u>{" "}
                        </b>
                        Standard GFP concentration curve derived from experimental data.
                      </figcaption>
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    The measurements taken with the OD meter yield a signal that exhibits a linear relationship 
                    with the concentration of GFP. This linear response enables us to compare various levels 
                    of GFP, making it possible in theory to differentiate between bacteria displaying GFP and 
                    those that do not.              
                  </p>
                </div>
                <div>{/*Preliminary Experiment*/}
                <h4 className="mb-2" id="Preliminary_GFP_Experiment_SpaC_s">Preliminary experiment: </h4>
                  <p className="mb-2">
                  Fluorescence measurements were conducted for conditions representing high (early induction), 
                  moderate (late induction), and absent (uninduced) levels of SpaC. Surprisingly, all three 
                  conditions yielded very low signals. Notably, the late-induced culture exhibited a lower 
                  signal compared to the negative control, while the early-induced culture had a signal slightly 
                  above the negative control. However, the differences between the negative control and the 
                  late-induced condition were nearly as significant as the differences between the negative 
                  control and the early-induced condition.<br></br>
                  As a result, this experiment was deemed inconclusive.
                  </p>

                  <div class="result-centered">
                    <figure>
                      <div id="Table2_SpaC"></div>
                      <Figure3/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 2:</u>{" "}
                        </b>
                        OD meter readings for fluorescence signal (Excitation: 488 nm, Emission: 509 nm) in 
                        various conditions - uninduced (no Spac expression), early induction (high SpaC levels), 
                        late induction (low SpaC levels). 
                      </figcaption>
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    Regrettably, the absence of a positive control rendered it unclear whether the inconclusive 
                    results stemmed from experimental optimization deficiencies or the bacteria's inability to 
                    present the construct on their surfaces. In an effort to diminish the possibility of an 
                    inadequate readout resulting from the experimental setup, a series of diverse conditions will 
                    be explored in the next experiment.                
                  </p>
                </div>
                <div>{/*Optimization of Experimental Setup*/}
                <h4 className="mb-2" id="Optimization_GFP_SpaC_s">Optimizing the experimental setup: </h4>
                  <p className="mb-2">
                  The low signal may result from insufficient bacteria or a scarcity of GFP. To optimize these 
                  factors, varying amounts of bacteria were incubated with different GFP concentrations. After 
                  washing, the fluorescence of the bacteria was measured. It is essential to note that the 
                  primary objective of this experiment was not to obtain conclusive results but rather to 
                  establish an optimal experimental setup for subsequent tests. Induced bacteria were used to 
                  potentially enhance the contrast between treated and untreated bacteria.<br></br>
                  We specifically focused on the signal difference between bacterial cultures incubated without 
                  GFP (negative control) and those incubated with GFP. Notably, incubating only 0.125 mL of 
                  bacterial culture did not reveal a discernible difference from the negative control. However, 
                  doubling the bacterial amount to 0.25 mL showed a 1.1-fold increase in signal for GFP-incubated 
                  bacteria. The contrast was even more pronounced with larger bacterial quantities, where both 
                  0.5 mL and 1 mL of bacterial culture exhibited a 1.3-fold increase in signal.
                  </p>

                  <div class="result-centered">
                    <figure>
                      <div id="Table3_SpaC"></div>
                      <Figure4/>                    
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 3:</u>{" "}
                        </b>
                        OD meter readings for fluorescence signal (excitation: 488 nm, emission: 509 nm) under 
                        different conditions, involving varied GFP concentrations and volumes of harvested 
                        bacterial culture. 
                        Culture.
                      </figcaption>
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    Both 0.5 mL and 1 mL cultures exhibited a notable contrast. The next step was to ascertain 
                    whether the observed difference was attributed to surface-bound nanobody retaining GFP or to 
                    the nonspecific adhesion of GFP to the bacterial surface.<br></br>
                    To account for potential variations in bacterial concentrations, we conducted subsequent 
                    experiments using a standardized setup of 1 mL of culture and 240 µg/mL of GFP.
                    </p>
                </div>
                <div>{/*Test with EC20 as negative control*/}
                <h4 className="mb-2" id="Experiment1_GFP_SpaC_s">Experiment 1: </h4>
                  <p className="mb-2">
                  Having established ideal conditions, an experiment was conducted using EC20-hosting bacteria 
                  as the negative control. In this experiment, 1 mL of bacteria was incubated with 240 µg/mL of 
                  GFP for a period of 1 hour.<br></br>
                  Regrettably, the obtained signal was notably low. Furthermore, the negative control displayed 
                  a signal more than three times higher than the SpaC expressing bacteria.
                  </p>

                  <div class="result-centered">
                    <figure>
                      <div id="Table1_SpaC"></div>
                      <Figure5/>                    
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 4:</u>{" "}
                        </b>
                        OD meter readings for fluorescence signal (excitation: 488 nm, emission: 509 nm) in 
                        bacteria expressing SpaC and the negative control (bacteria hosting the EC20 plasmid). 
                      </figcaption>
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    It was unclear whether SpaC was not expressed on the surface, or if the experimental setup 
                    was unable to detect it. The absence of a positive control compelled us to shift our approach 
                    and explore alternative methods for detecting surface expression. <br></br>
                    <u><b>Remark:</b></u><br></br>
                    It's worth mentioning that, at this stage, we were not yet aware of the peculiar phenotype 
                    associated with the EC20 construct. The diminutive size of the bacteria led to a greater 
                    total surface area per unit volume, and the strong adhesion between individual bacteria 
                    might be attributed to a non-specific attraction of EC20 to other proteins, possibly 
                    including GFP.                  
                  </p>
                </div>
                <div>{/*Microscope*/}
                <h4 className="mb-2" id="Microscope_GFP_s">Microscopic analysis: </h4>
                  <p className="mb-2">
                    Because of the GFP-nanobody fused to the SpaC construct, when bacteria are incubated with 
                    GFP, it results in the binding of GFP to the surface protein. Theoretically, the 
                    fluorescence of GFP can be visualized under the microscope, similar to the approach used by 
                    Glass et al. in 2018{" "}<a href="#reference4_SpaC">{" "}<sup>4</sup>{" "}</a>. However, when we imaged the bacteria under the microscope, 
                    no discernible difference was observed between the control and the incubated bacteria.
                  </p>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    The combination of GFP incubation with the GFP-Nanobody in our construct did not appear to be 
                    a promising approach. We therefore explored alternative experimental methods to confirm 
                    surface expression.                
                  </p>
                </div>
                
              </div>
              <div>{/*Proteinase K*/}
                <div>{/*Experiment 1*/}
                <h4 className="mb-2" id="PK_Experiment_SpaC_s">Proteinase K assay: </h4>
                  <p className="mb-2">
                    To confirm the surface display of our proteins of interest, we conducted an experiment 
                    utilizing the enzyme proteinase K (PK). Proteinase K is able to degrade extracellular 
                    proteins but cannot penetrate bacterial cells. When a protein is present prior to PK 
                    treatment and absent afterward, it signifies susceptibility to proteinase K and, 
                    consequently, surface display.<br></br>
                    While the Ponceau S staining for SpaC indicates equal loading of protein with well-aligned 
                    lanes (<a href="#Figure5_SpaC">Figure 2</a>), the Western blot revealed not only the 
                    anticipated band at approximately 120 kDa but also multiple other bands at lower molecular 
                    weights (<a href="#Figure6_SpaC">Figure 3</a>). Interestingly, no noticeable distinction was 
                    observed between the treated sample, the initial time point (TP0), and the negative control 
                    (PK-). This suggests that either SpaC is not effectively displayed on the surface, or there 
                    may be issues with the experimental setup.
                  
                  </p>
                  <div class="result-centered">                    
                    <figure>
                      <div class='result-div'>{/**Ponceau S */}
                        <img
                            id="Figure5_SpaC"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/proteinase-k-spac-ponceau-s.jpg"
                            alt="results proteinase k ponceau s spac"
                            class="result-image"
                            style={{ width: "80%" }}
                          />
                          <br></br>
                          <figcaption className="mt-2 mb-10">
                            <b>
                              <u>Figure: 2</u>{" "}
                            </b>
                            Ponceau S staining of Western-blot for SpaC-hosting bacteria - before PK treatment 
                            (TP0), after PK treatment (PK+), negative control (PK-).
                          </figcaption>
                      </div>
                      <div class='result-div'>{/**Western */}
                          <img
                            id="Figure6_SpaC"
                            src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/proteinase-k-spac-western.jpg"
                            alt="results proteinase k western spac"
                            class="result-image"
                            style={{ width: "77%" }}
                          />
                          <figcaption className="mt-[-1rem] mb-10">
                            <b>
                              <u>Figure 3:</u>{" "}
                            </b>
                            Western-blot of SpaC-hosting bacteria - before PK treatment (TP0), after PK treatment 
                            (PK+), and negative control (PK-). 

                          </figcaption>
                      </div>                                                                                     
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    Given the lack of differentiation observed between the negative control and PK treatment, 
                    our next step involved planning a follow-up experiment to assess the enzymatic activity and 
                    effectiveness of our proteinase K (PK).             
                  </p>
                  </div>
                  <div>{/*Enzymatic Assay*/}
                <h4 className="mb-2" id="Enzymatic_Assay_PK_SpaC_s">Proteinase K - enzymatic activity assay: </h4>
                  <p className="mb-2">
                  The evaluation of PK activity involves dissolving GFP in water containing PK and measuring 
                  fluorescence. Over time, PK should degrade all GFP, leading to the complete absence of 
                  detectable fluorescence.<br></br>
                  <a href="#Table5_SpaC">Table 5</a> displays fluorescence measurements before and after 
                  incubation with PK under various conditions. Please note that the machine did not provide a 
                  specific unit for these values.<br></br>
                  To normalize the measured change, the percentage change from the initial signal to the final 
                  signal is provided in <a href="#Table6_SpaC">Table 6</a>.
                  We did not observe degradation exceeding 30% in any of the tested conditions. In a single 
                  condition, a signal increase was detected, which we attribute to potential random variation. 
                  Nevertheless, we interpreted this as minimal to no sample degradation.
                  </p>

                  <div class="result-centered">
                    <figure>
                      <div  id="Table5_SpaC"></div>
                      <Figure10/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 5:</u>{" "}
                        </b>
                        Different concentrations of GFP were incubated with PK at various temperatures. The first 
                        value represents the initial signal, while the value following the arrow represents the 
                        signal after incubation. 
                      </figcaption>
                      <br></br>
                      <div  id="Table6_SpaC"></div>
                      <Figure11/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 6:</u>{" "}
                        </b>
                        Percentage change in fluorescence (excitation: 488 nm, emission: 509 nm) pre- and 
                        post-incubation with PK across diverse GFP concentrations and temperatures. Blue denotes 
                        signal reduction, while orange signifies enhancement.
                      </figcaption>
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    For our experiments, complete protein degradation is necessary. However, due to the 
                    insufficient enzymatic activity of our PK, we decided to discontinue the proteolytic assay. 
                    To confirm the presence of the protein on the surface, we adopted an immunofluorescence (IF) 
                    approach.                 
                  </p>
                </div>
              </div>       
            </div>
            <div>{/*Sonication */} 
              <div>{/*Sonication*/}
              <h3 className="mt-10 mb-5" id="Sonication_SpaC_s">Sonication: </h3>
                  <p className="mb-2">

                  To improve resolution and eliminate unwanted non-protein debris, we utilized sonication to 
                  disrupt the bacteria, and then performed centrifugation to remove undesirable material. The 
                  resulting supernatant containing proteins was collected for use in subsequent experiments.<br></br>
                  To quantify the protein, we conducted a BCA assay. We prepared a dilution series of the BCA 
                  standard and generated a standard curve using the signal values obtained (as shown in 
                  <a href="#Table7_SpaC">Table 7</a> and <a href="#Figure7_SpaC">Figure 4</a>). <br></br>

                 
                  A linear regression analysis was conducted to estimate the concentration based on the signal, 
                  resulting in the following relationship: <br></br><br></br>
                  <center>C(S)=1.869*S+0.213<br></br><br></br></center>
                  Where C is the concentration to be calculated, and S is the signal measured.<br></br>
                  The R-squared value quantifies the degree to which the observed data points align with the 
                  linear regression obtained. A perfect match is represented by a value of 1. We obtained an 
                  R-squared value of 0.997, indicating that the model accurately represents the concentrations 
                  derived from the signals.<br></br>
                  <a href="#Table8_SpaC">Table 8</a> displays the recorded signals along with the corresponding 
                  computed concentrations. <br></br>

                  Before preparing the Western blot, we boiled the proteins. Our addition of 2X SDS loading dye 
                  further diluted the samples by a factor of 1:2.<br></br>
                  The target protein load was established at 40 µg. Nevertheless, because of the volume 
                  limitations of a single gel well (40 µL), there was a restriction on the maximum quantity of 
                  protein that could be loaded. Table 4 demonstrates the highest permissible protein load for 
                  each condition. The data shows that none of the samples had a concentration adequate to the 
                  required amount of protein.


                  </p>
                  <p className=" mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    Sonication proved ineffective in yielding sufficient protein for our experiments. Given the 
                    challenges associated with the 50 mL volume, including space limitations in the incubator 
                    and high LB medium consumption, we chose not to repeat the experiment with larger volumes. 
                    In subsequent experiments, we no longer employed sonication.                
                  </p>

                  <div class="result-centered">
                    <figure>
                      <div id="Table7_SpaC"></div>
                      <Figure6/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 7:</u>{" "}
                        </b>
                        BCA assay results for the dilution series. 
                      </figcaption>
                      <br></br>
                      <div id="Figure7_SpaC"></div>
                      <Figure7/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure: 4</u>{" "}
                        </b>
                        Standard curve for OD 562 based on experimental data.
                      </figcaption>
                      <div id="Table8_SpaC"></div>
                      <Figure8/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 8:</u>{" "}
                        </b>
                        Measured signals, corresponding concentrations, and protein mass in 40 µL for three Samples.   
                      </figcaption>
                    </figure>
                  </div>

                  <p className="mb-2">{/*Outlook */}
                    <u><b>Outlook:</b></u><br></br>
                    Sonication proved ineffective in yielding sufficient protein for our experiments. Given the 
                    challenges associated with the 50 mL volume, including space limitations in the incubator and 
                    high LB medium consumption, we have chosen not to repeat the experiment with larger volumes. 
                    In subsequent experiments, we will no longer employ sonication.                
                  </p>
                </div>

            </div>
          </div>

        <div>{/**References */}
        <h2 className="mt-20" id="References_s"> References </h2>
        <hr className="dividergeneral mb-5" />
        <ul>
          <ol type="1">
            <li id="reference1_SpaC">
              {" "}
              Grossman, Trudy H., et al. <br/>
              <a href="https://www.sciencedirect.com/science/article/pii/S0378111998000201">
              "Spontaneous cAMP-dependent derepression of gene expression in 
              stationary phase plays a role in recombinant expression instability." Gene 209.1-2 (1998): 95-103.
              </a>  
            </li>
            <li id="reference2_SpaC">
              {" "}
              Topp, Shana, et al.<br/>
              <a href="https://open.library.emory.edu/publications/emory:s6637/">
               "Synthetic riboswitches that induce gene expression in diverse bacterial 
              species." Applied and environmental microbiology 76.23 (2010): 7881-7884. 
              </a>
            </li>
            <li id="reference3_SpaC">
              {" "}
              Kant, Abhiruchi, et al.<br/>
              <a href="https://www.sciencedirect.com/science/article/pii/S1047847720301441"> 
               "Crystal structure of lactobacillar SpaC reveals an atypical five-domain pilus tip adhesin: 
               Exposing its substrate-binding and assembly in SpaCBA pili." Journal of Structural Biology 211.3 
               (2020): 107571.
              </a>
            </li>
            <li id="reference4_SpaC">
              {" "}
              Glass, David S., and Ingmar H. Riedel-Kruse. <br/>
              <a href="https://www.cell.com/cell/pdf/S0092-8674(18)30844-4.pdf"> 
               "A synthetic bacterial cell-cell adhesion toolbox for programming multicellular morphologies and 
               patterns." Cell 174.3 (2018): 649-658.
              </a>
            </li>
          </ol>
        </ul>
        </div>
      </div>
    </div>
  );
};

export default Article;
